// extracted by mini-css-extract-plugin
export default {"prefilledAttributeDateInput":"prefilled-attribute-date-component__prefilled-attribute-date-input__zUELD"};